import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useCopyToClipboard } from "~/components/CopyToClipboard";
import { Tooltip } from "~/components/Tooltip";
import { ApiKey } from "../../types";
import { faClone } from "@fortawesome/pro-solid-svg-icons";
import { getBadgeClassName } from "~/components/Badge/component";

// // // //

/**
 * CopyKeyButton
 * Copies an API Key to the user's clipboard
 */
export function CopyKeyButton(props: { apiKey: ApiKey }) {
    const { apiKey } = props;

    // Setup CopyToClipboard hook w/ useState to dipslay "Copied" message
    const [copied, setCopied] = useState<boolean>(false);
    const [copyToClipboard] = useCopyToClipboard(() => {
        setCopied(true);
    });

    useEffect(() => {
        if (copied === true) {
            setTimeout(() => {
                setCopied(false);
            }, 1000);
        }
    }, [copied]);

    const message: string = copied ? "Copied!" : "Copy to Clipboard";

    return (
        <Tooltip
            placement="top"
            tooltipWrapperClassName="bg-card border-blue-500 rounded-full"
            tooltipContent={
                <div className="w-40 px-2 py-1 text-center text-xs">
                    <p className="whitespace-nowrap text-link">{message}</p>
                </div>
            }
        >
            {({ setTriggerRef }) => (
                <button
                    ref={setTriggerRef}
                    className={getBadgeClassName({
                        className:
                            "flex items-center justify-start md:justify-between font-mono",
                        size: "sm",
                        variant: "blue",
                    })}
                    onClick={() => {
                        copyToClipboard(apiKey.key);
                    }}
                >
                    <span className="">
                        {apiKey.key.substring(0, 24) + "..."}
                    </span>
                    <FontAwesomeIcon icon={faClone} className="h-3 ml-1" />
                </button>
            )}
        </Tooltip>
    );
}
